export default __webpack_public_path__ + "static/media/quintessent.679c13e3.png";